import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, isAuthReady, user, hasActiveSubscription } = useAuth();

  if (isLoading || (isAuthenticated && !isAuthReady)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-medical-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (user && user.consentsCompleted === false) {
    return <Navigate to="/signup" replace />;
  }

  const isAdmin = user?.roles?.includes('ADMIN');
  if (!hasActiveSubscription && !isAdmin) {
    return <Navigate to="/signup" replace />;
  }

  if (user && user.emailVerified === false && !isAdmin) {
    return <Navigate to="/verify-email/pending" replace />;
  }

  return <>{children}</>;
};
